import { useState } from "react";
import { featuredPost, digPosts, type Post } from "@/mocks/homeContent";

const chips = ["全部深挖帖", "进行中", "已还原", "待跟进"];

function tagStyle(tone: Post["tagTone"]) {
  switch (tone) {
    case "primary":
      return "bg-primary-100 text-primary-800";
    case "accent":
      return "bg-accent-100 text-accent-800";
    default:
      return "bg-secondary-100 text-secondary-900";
  }
}

export default function DigFeed() {
  const [active, setActive] = useState("全部深挖帖");

  return (
    <section id="dig" className="w-full bg-background-50">
      <div className="container-x py-12 md:py-16">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-primary-600">
              <i className="ri-quill-pen-line" />
              深挖帖 · 全程记录
            </p>
            <h2 className="font-heading mt-2 text-2xl font-black md:text-4xl">最新深挖帖</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-500">
              大小卡片混排，图文并重。每条深挖帖都标注当前还原阶段，跟进中的现场会持续续写。
            </p>
          </div>

          <div className="inline-flex w-max flex-wrap items-center gap-1 rounded-full bg-secondary-100 p-1">
            {chips.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
                  active === c ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.3fr_1fr]">
          {/* 大卡：主打深挖帖 */}
          <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative block h-56 w-full overflow-hidden md:h-72">
              <img
                src={featuredPost.image}
                alt={featuredPost.title}
                className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute left-4 top-4 flex items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-fire-fill animate-flame" /> 热度 {featuredPost.heat}
                </span>
              </div>
              <span className="absolute bottom-4 left-4 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-foreground-800">
                {featuredPost.meta}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <div className="flex items-center gap-2">
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-bold text-primary-800">
                  {featuredPost.tag}
                </span>
                <span className="inline-flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-time-line" /> 扒皮现场持续更新
                </span>
              </div>
              <h3 className="font-heading mt-3 text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                {featuredPost.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{featuredPost.digest}</p>
              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-400">本文更新于 2026.09.06</span>
                <span className="inline-flex items-center gap-1 text-sm font-bold text-primary-600 transition-colors group-hover:text-primary-500">
                  进入深挖帖
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </article>

          {/* 小卡群 */}
          <div className="grid grid-cols-1 content-start gap-4 sm:grid-cols-2">
            {digPosts.map((p) => (
              <article
                key={p.title}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
              >
                <div className="relative h-36 w-full overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-foreground-800">
                    <i className="ri-fire-line text-accent-600" />
                    {p.heat}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <div className="flex items-center gap-2">
                    <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${tagStyle(p.tagTone)}`}>
                      {p.tag}
                    </span>
                    <span className="text-[11px] text-foreground-400">{p.status}</span>
                  </div>
                  <h3 className="mt-2 text-sm font-bold leading-snug text-foreground-950 md:text-[15px]">
                    {p.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-500">
                    {p.digest}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}